import styled from "styled-components";

export const Content = styled.div`
    display: grid;
    row-gap: 32px;
`;
